<template>
  <div class="users-search">
    <!-- SHOW USERS -->
    <template v-if="users.length">
      <h3>
        @{{ search }}
      </h3>
      <div class="card">
        <user-basic
          v-for="(user, index) in users"
          :key="user.id"
          :user="user"
          :last="index === users.length - 1"
        />
      </div>
    </template>

    <!-- LOADING -->
    <template v-else-if="loading">
      <spinner
        preset="large"
      />
    </template>

    <!-- Error -->
    <template v-else-if="error">
      <div
        class="alert alert-danger"
        role="alert"
      >
        An error occurred while trying to load your feed. Please check your
        connection and try again.
      </div>

      <button
        type="button"
        class="btn btn-outline-primary"
        @click="loadUsers"
      >
        Try Again
      </button>
    </template>

    <!-- NO RESULTS -->
    <template v-else>
      <div
        class="alert alert-secondary"
        role="alert"
      >
        No users match your search, please try a new search.
      </div>
    </template>
  </div>
</template>

<script>
import UserBasic from '@/components/UserBasic.vue';

export default {
  name: 'UsersSearch',
  components: {
    UserBasic,
  },
  props: {
    search: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      users: [],
      loading: false,
      error: false,
    };
  },
  watch: {
    search() { this.loadUsers(); },
  },
  created() {
    this.loadUsers();
  },
  methods: {
    reset() {
      this.users = [];
      this.loading = false;
      this.error = false;
    },
    async loadUsers() {
      this.reset();

      this.loading = true;
      const responseData = await this.api({ url: 'users/search/', method: 'GET', params: { search: this.search } });
      this.loading = false;

      if (responseData.status === 200) {
        this.users = responseData.body;
      } else {
        this.error = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  padding-top: 20px;
  padding-bottom: 20px;
}
</style>
